import { DocumentFile } from './document-file-model';
import { DocumentProcessTo } from './document-process-to.model';

export class DocumentProcess {
    id: number;
    name: string;
    description: string;
    creationDate: Date;
    updateDate: Date;
    documentFileId: number;
    documentFile: DocumentFile;
    constancyType: string;
    constancyNumber: string;
    registrationNumber: string;
    documentProcessToAssigns: DocumentProcessTo [];
    assingTo: DocumentProcessTo;
}

export function DefaultDocumentProcess(): DocumentProcess {
    let newDocumentProcess = new DocumentProcess();
    let newDocumentFile = new DocumentFile();
    let newDocumentProcessTo = new DocumentProcessTo();

    newDocumentProcess.constancyType = '';
    newDocumentProcess.constancyNumber = '';
    newDocumentProcess.registrationNumber = '';
    newDocumentProcess.documentFile = newDocumentFile;
    newDocumentProcess.assingTo = newDocumentProcessTo;

    return newDocumentProcess;
}